export const ActiveModules = process.env.NEXT_PUBLIC_ACTIVE_MODULES?.split(
  ','
).map(m => m.trim()) || ['shop', 'submission'];

export enum ModuleName {
  SHOP = 'shop',
  CLUB = 'club',
  SUBMISSION = 'submission',
  SOG = 'sog',
  XPLAN = 'xplan',
}

export enum SogFeature {
  PRODUCTS = 'products',
  FABRICS = 'fabrics',
  ACCESSORIES = 'accessories',
  SEMI_PRODUCT = 'semi-product',
}

export const ActiveSogFeatures =
  process.env.NEXT_PUBLIC_SOG_FEATURES?.split(',').map(f => f.trim()) ?? [];

export const ModuleRoutes: Record<string, string[]> = {
  [ModuleName.SHOP]: [
    '/[lang]/admin/shop',
    '/[lang]/cart',
    '/[lang]/payment',
    '/[lang]/shipping',
    '/[lang]/shop',
  ],
  [ModuleName.CLUB]: ['/[lang]/club', '/[lang]/admin/club'],
  [ModuleName.SOG]: ['/[lang]/admin/sog'],
  [ModuleName.SUBMISSION]: ['/[lang]/submission', '/[lang]/admin/submission'],
  [ModuleName.XPLAN]: ['/[lang]/xplan', '/[lang]/admin/xplan'],
};

export const InactiveModules = Object.keys(ModuleRoutes).filter(
  moduleName => !ActiveModules.includes(moduleName)
);

export function isModuleActive(moduleName: ModuleName): boolean {
  return ActiveModules.includes(moduleName);
}

export function isModuleInactive(moduleName: ModuleName): boolean {
  return !ActiveModules.includes(moduleName);
}

export function isSogFeatureActive(feature: SogFeature) {
  return ActiveSogFeatures.includes(feature);
}